import { Download } from "lucide-react";
import { useTranslation } from "react-i18next";

import EarthSvg from "@/assets/common/other_icons/earth.svg?react";
import useSegmentEvent from "@/hooks/useSegmentEvent";

import BaseCard, { ActionButton } from "./BaseCard";

function DownloadActionPlan({ url }: { url?: string }) {
  const { t } = useTranslation(["communicate", "common"]);
  const { sendSegmentEvent } = useSegmentEvent();

  return (
    <BaseCard
      title={t("communicate:downloadActionPlan.title")}
      text={t("communicate:downloadActionPlan.text")}
      Icon={EarthSvg}
    >
      <ActionButton
        to={url}
        onClick={() => sendSegmentEvent("action_plan_downloaded")}
      >
        <Download />
        {t("common:download")}
      </ActionButton>
    </BaseCard>
  );
}

export default DownloadActionPlan;
